export function omittedText(text) {
    if (typeof text !== "string") {
        return "";
    }

    return text.length > 50 ? text.slice(0, 50) + "…" : text;
}

export function rmTag(text) {
    // info_detail は nullable。文字列以外が渡ると text.replace で落ちるため型で弾く
    if (typeof text !== "string") {
        return "";
    }

    let m = text.replace(/(<([^>]+)>)/gi, "");
    let msg = m.replace(/\s|&nbsp;/g, " ");

    return msg;
}
